import ShipFrom from './Fields/ShipFrom.js'
import PackingList from './Fields/PackingList.js'
import {BillToNotify, NotifyNotice, ShipToNotify} from './Fields/Notify.js'
import SingleWeight from './Fields/SingleWeight.js'
import SingleDimensions from './Fields/Dimensions/SingleDimensions.js'
import EditAdditionalOptions from './SingleLabelConfigForm/EditAdditionalOptions.js'
import {useSelector} from '../../store.js'
import {
  labelInfoSelector,
  shipperTypesSelector,
} from '../../data/labelInfos/index.js'
import LabelConfigContext, {
  useLabelConfigContext,
} from './LabelConfigContext.js'
import {FEDEX, UPS} from '../../common/constants/ShipperNames.js'
import ResidentialAddress from './Fields/ResidentialAddress.js'
import AttachHazmatInfo from './SingleLabelConfigForm/AttachHazmatInfo.js'
import TaxInfo from './Fields/TaxInfo.js'
import PackagingWeight from './Fields/PackagingWeight.js'
import ReferenceNumber from './Fields/ReferenceNumber.js'
import DeliveryConfirmation from './Fields/DeliveryConfirmation.js'
import CertificateOrigin from './Fields/CertificateOrigin.js'
import SaturdayDelivery from './Fields/SaturdayDelivery.js'
import DirectDelivery from './Fields/UPS/DirectDelivery.js'
import AdditionalHandling from './Fields/UPS/AdditionalHandling.js'
import DeclaredValue from './Fields/DeclaredValue.js'
import DryIceWeight from './Fields/DryIceWeight.js'
import ShipperRelease from './Fields/UPS/ShipperRelease.js'
import {Payor, PayorAccountNumber, PayorZipcode} from './Fields/Payor.js'
import {
  DutiesPayor,
  DutiesPayorAccountNumber,
  DutiesPayorZipcode,
} from './Fields/DutiesPayor.js'
import MailInnovations from './Fields/UPS/MailInnovations.js'
import USPSEndorsement from './Fields/UPS/USPSEndorsement.js'
import ReasonForExport, {
  ReasonForExportExplanation,
} from './Fields/ReasonForExport.js'
import CostCenter from './Fields/UPS/CostCenter.js'
import PackageBillType from './Fields/PackageBillType.js'
import EnableNotifications from './Fields/EnableNotifications.js'
import CarrierPickup from './Fields/AmazonSFP/CarrierPickup.js'
import {
  IncludeImporterOfRecord,
  ImporterOfRecord,
} from './SingleLabelConfigForm/IncludeImporterOfRecord.js'
import PickupDateRange from './Fields/PickupDateRange.js'
import DangerousGoods from './Fields/DangerousGoods.js'
import ETDService from './Fields/FedEx/ETDService.js'
import HoldAtLocation from './Fields/HoldAtLocation.js'
import HoldForPickup from './Fields/Endicia/HoldForPickup.js'
import ServiceEndorsement from './Fields/ServiceEndorsement.js'
import NonstandardDay from './Fields/DHL/NonstandardDay.js'
import NonstandardContents from './Fields/DHL/NonstandardContents.js'
import FederalTaxID from './Fields/DHL/FederalTaxID.js'
import StateTaxID from './Fields/DHL/StateTaxID.js'
import SmartPostIndicia from './Fields/FedEx/SmartPostIndicia.js'
import SmartPostHub from './Fields/FedEx/SmartPostHub.js'
import AlcoholShipmentLicense from './Fields/AlcoholShipmentLicense.js'
import SignatureRequired from './Fields/DHL/SignatureRequired.js'
import IsDutiable from './Fields/DHL/IsDutiable.js'
import {
  ForeignTradeRegulation,
  ForeignTradeRegulationNotice,
  InternalTransactionNumber,
} from './Fields/DHL/ForeignTradeRegulation.js'
import ContentsType from './Fields/Endicia/ContentsType.js'
import NondeliveryOption from './Fields/NondeliveryOption.js'
import ServiceOption from './Fields/CanadaPost/ServiceOption.js'
import MailingZipCode from './Fields/MailingZipCode.js'
import DeliveryInstructions from './Fields/DeliveryInstructions.js'
import InvoiceNumber from './Fields/InvoiceNumber.js'
import PurchaseOrderNumber from './Fields/PurchaseOrderNumber.js'
import DepartmentNumber from './Fields/DepartmentNumber.js'
import InsuredValue from './Fields/InsuredValue.js'
import ReturnReason from './Fields/ReturnReason.js'
import DryIceRegulationSet from './Fields/DryIceRegulationSet.js'
import AlternateReturnToAddress from './Fields/AlternateReturnToAddress.js'
import PharmacyDelivery from './Fields/PharmacyDelivery.js'
import SubPackageType from './Fields/SubPackageType.js'
import PriorityAlert from './Fields/PriorityAlert.js'
import LabelType from './Fields/LabelType.js'
import AttachCustomsInfo from './Fields/AttachCustomsInfo.js'
import ETDPreshipmentDocs from './Fields/ETDPreshipmentDocs.js'
import AncillaryEndorsement from './Fields/AncillaryEndorsement.js'
import OneRate from './Fields/OneRate.js'
import B13AFilingOption from './Fields/B13AFilingOption.js'
import ExportComplianceStatement from './Fields/ExportComplianceStatement.js'
import ParcelCharacteristics from './Fields/ParcelCharacteristics.js'
import HasNonstandardCharacteristics from './Fields/HasNonstandardCharacteristics.js'
import {BatteryMaterial, BatteryPackaging} from './Fields/BatteryMaterial.js'
import IgnoreBadAddress from './Fields/IgnoreBadAddress.js'
import ShipDate from './Fields/ShipDate.js'
import PickupDate from './Fields/PickupDate.js'
import ShippingMethod from './Fields/ShippingMethod.js'
import ShippersFilter from './Fields/ShippersFilter.js'
import IncludeAdditionalProperties from './Fields/IncludeAdditionalProperties.js'
import SingleInsurance from './Fields/Insurance/SingleInsurance.js'
import PackageTypesFilter from './Fields/PackageTypesFilter.js'
import ShippingMethodFilter from './Fields/ShippingMethodFilter.js'
import DangerousGoodsCode from './Fields/DangerousGoodsCode.js'
import InsuranceType, {InsuranceTypeNotice} from './Fields/InsuranceType.js'
import TermsOfSale from './Fields/TermsOfSale.js'
import IsHazmat from './Fields/IsHazmat.js'
import PreserveRateSelection from './Fields/PreserveRateSelection.js'
import SendEUProductIdentifiers from './Fields/SendEUProductIdentifiers.js'
import SenderType from './Fields/SenderType.js'
import ReceiverType from './Fields/ReceiverType.js'

export const LABEL_PROPERTIES = {
  baseline: [
    [SingleWeight, SingleDimensions],
    ShipFrom,
    PackingList,
    [BillToNotify, ShipToNotify, NotifyNotice],
    ResidentialAddress,
  ],
  additional: [
    AttachCustomsInfo,
    SendEUProductIdentifiers,
    AttachHazmatInfo,
    TaxInfo,
    IncludeImporterOfRecord,
    ImporterOfRecord,
    ETDService,
    ETDPreshipmentDocs,
    AlternateReturnToAddress,
    // Checkboxes
    [
      EnableNotifications,
      CarrierPickup,

      CertificateOrigin,
      SaturdayDelivery,
      HoldAtLocation,
      HoldForPickup,
      SignatureRequired,
      IsDutiable,
      ShipperRelease,
      AdditionalHandling,
      DirectDelivery,
      PharmacyDelivery,
      OneRate,
      HasNonstandardCharacteristics,
      IsHazmat,
    ],
    IgnoreBadAddress,

    // Dates
    ShipDate,
    PickupDate,
    PickupDateRange,

    // Weights
    PackagingWeight,
    DryIceWeight,
    DryIceRegulationSet,

    // Currency
    DeclaredValue,
    InsuredValue,
    InsuranceType,
    InsuranceTypeNotice,

    // Selects
    DangerousGoods,
    DangerousGoodsCode,
    DeliveryConfirmation,
    ServiceEndorsement,
    NonstandardDay,
    NonstandardContents,
    Payor,
    PayorAccountNumber,
    PayorZipcode,
    DutiesPayor,
    DutiesPayorAccountNumber,
    DutiesPayorZipcode,
    SmartPostIndicia,
    SmartPostHub,
    AncillaryEndorsement,
    AlcoholShipmentLicense,
    ForeignTradeRegulation,
    ForeignTradeRegulationNotice,
    InternalTransactionNumber,
    ContentsType,
    ReasonForExport,
    ReasonForExportExplanation,
    TermsOfSale,
    NondeliveryOption,
    ServiceOption,
    PackageBillType,
    SubPackageType,
    SenderType,
    ReceiverType,
    B13AFilingOption,
    ExportComplianceStatement,
    LabelType,
    PriorityAlert,
    ParcelCharacteristics,
    BatteryMaterial,
    BatteryPackaging,

    // Text
    FederalTaxID,
    StateTaxID,
    MailInnovations,
    CostCenter,
    USPSEndorsement,
    MailingZipCode,
    DeliveryInstructions,
    InvoiceNumber,
    PurchaseOrderNumber,
    DepartmentNumber,
    ReturnReason,
    ReferenceNumber,

    ShippingMethod, // Keep last
  ],
}

LABEL_PROPERTIES.preset_top_level = [
  ShippersFilter,
  PackageTypesFilter,
  ShippingMethodFilter,
  PreserveRateSelection,
  IncludeAdditionalProperties,
  ...LABEL_PROPERTIES.baseline,
  SingleInsurance,
]

LABEL_PROPERTIES.preset_summary = LABEL_PROPERTIES.additional.filter(
  (Component) => Component !== ShippingMethod,
)

export function BaseLineProperties() {
  return (
    <>
      {LABEL_PROPERTIES.baseline.map((Component, index) => {
        if (Array.isArray(Component)) {
          return (
            <li key={index} className="list__item--no-style">
              <ul className="list flex flex-wrap flex-wrap-margin-10">
                {Component.map((C, i) => (
                  <C key={i} />
                ))}
              </ul>
            </li>
          )
        }

        return <Component key={index} />
      })}
    </>
  )
}

function onlyEnabledOptionsSelector(
  state,
  {labelInfoID, shipperTypes, Components},
) {
  let {properties} = labelInfoSelector(state, {labelInfoID})
  const onlyEnabledOptions = []
  for (const Component of Components) {
    if (properties.length === 0) {
      // either none were enabled or other components claimed the properties
      break
    }

    const propertySpecs = Component.propertySpecList?.[0]

    if (!propertySpecs) {
      continue
    }

    const {validShipperTypes, labelPropertiesFunc, validLabelPropertiesFunc} =
      propertySpecs

    const subsetOfValidShipperTypes = validShipperTypes.filter((shipperType) =>
      shipperTypes.includes(shipperType),
    )

    const validLabelProperties = validLabelPropertiesFunc(
      subsetOfValidShipperTypes,
      labelPropertiesFunc,
      labelInfoID,
    )

    // sort into two buckets:
    // those that are related to this component
    // everything else to be match with subsequent components
    // this assumes no label property is shared with multiple components
    let [relatedProperties, unrelatedProperties] = properties.reduce(
      (prev, lp) => {
        if (validLabelProperties.includes(lp)) {
          prev[0].add(lp)
        } else {
          prev[1].push(lp)
        }

        return prev
      },
      [new Set(), []],
    )

    // will eventually become empty
    properties = unrelatedProperties

    if (relatedProperties.size === 0) {
      continue
    }

    // run through all valid shippers from the supplied shipperTypes
    for (const shipperType of subsetOfValidShipperTypes) {
      const labelProperties = labelPropertiesFunc(shipperType, labelInfoID)

      if (labelProperties.some((lp) => relatedProperties.has(lp))) {
        onlyEnabledOptions.push({
          additionalContext: {shipperType},
          Component,
        })

        for (const labelProperty of labelProperties) {
          relatedProperties.delete(labelProperty)
        }
      }
    }
  }

  return onlyEnabledOptions
}

function allOptionsSelector(state, {labelInfoID, shipperTypes, Components}) {
  const allOptionsMap = new Map()
  for (const Component of Components) {
    const propertySpecs = Component.propertySpecList?.[0]

    if (!propertySpecs) {
      continue
    }

    const {validShipperTypes, labelPropertiesFunc} = propertySpecs

    const subsetOfValidShipperTypes = validShipperTypes.filter((shipperType) =>
      shipperTypes.includes(shipperType),
    )

    const labelPropertyMap = new Map()
    // run through all valid shippers from the supplied shipperTypes
    for (const shipperType of subsetOfValidShipperTypes) {
      const [labelProperty] = labelPropertiesFunc(shipperType, labelInfoID)
      labelPropertyMap.set(labelProperty, shipperType)
    }

    for (const [labelProperty, shipperType] of labelPropertyMap.entries()) {
      allOptionsMap.set(labelProperty, {
        additionalContext: {
          shipperType,
        },
        Component,
      })
    }
  }

  return Array.from(allOptionsMap.values())
}

function additionalOptionsSelector(
  state,
  {
    labelInfoID,
    shipperTypes,
    isLabelEnableMode,
    onlyEnabled,
    isPickMode,
    properties,
  },
) {
  if (!isLabelEnableMode || !(onlyEnabled || isPickMode)) {
    return properties
  }

  const Components = []
  for (const Component of properties) {
    if (Array.isArray(Component)) {
      for (const C of Component) {
        Components.push(C)
      }
    } else {
      Components.push(Component)
    }
  }

  return onlyEnabled
    ? onlyEnabledOptionsSelector(state, {labelInfoID, shipperTypes, Components})
    : allOptionsSelector(state, {labelInfoID, shipperTypes, Components})
}

/**
 * Additional Properties
 *
 * @param {Object} props
 * @param {Array} shipperTypes
 * @param {Boolean} [onlyEnabled]
 * @param {Array} properties // predefined list of label config properties to use
 * @returns {React.ReactNode}
 */
export function AdditionalProperties({
  shipperTypes,
  onlyEnabled,
  properties = LABEL_PROPERTIES.additional,
}) {
  const context = useLabelConfigContext()
  const {labelInfoID, isLabelEnableMode, isSummary, isPickMode} = context
  const additionalOptions = useSelector((state) =>
    additionalOptionsSelector(state, {
      labelInfoID,
      shipperTypes,
      isLabelEnableMode,
      onlyEnabled,
      isPickMode,
      properties,
    }),
  )

  if (isSummary && additionalOptions.length === 0) {
    return 'None selected'
  }

  let propertyInstances = additionalOptions.reduce((prev, Component, index) => {
    if (Array.isArray(Component)) {
      if (isSummary) {
        prev.push(...Component.map((C, i) => <C key={`${index}__${i}`} />))
      } else {
        prev.push(
          <li key={index} className="list__item--shipping-options">
            <ul className="list list--shipping-options flex flex-wrap flex-wrap-margin-15 flex-grow">
              {Component.map((C, i) => (
                <C key={i} />
              ))}
            </ul>
          </li>,
        )
      }
    } else if (Component.additionalContext) {
      prev.push(
        <LabelConfigContext.Provider
          key={index}
          value={{
            ...context,
            ...Component.additionalContext,
          }}
        >
          <Component.Component />
        </LabelConfigContext.Provider>,
      )
    } else {
      prev.push(<Component key={index} />)
    }

    return prev
  }, [])

  if (isSummary) {
    propertyInstances = propertyInstances.reduce((prev, property, index) => {
      if (property) {
        prev.push(property)
        prev.push(<span key={`${index}__comma`}>, </span>)
      }

      return prev
    }, [])

    propertyInstances.pop()
  }

  return <>{propertyInstances}</>
}

export default function LabelConfigForm() {
  const {labelInfoID} = useLabelConfigContext()
  const shipperTypes = useSelector((state) =>
    shipperTypesSelector(state, {labelInfoID}),
  )

  return (
    <div>
      <ul className="list list--shipping-options margin-bottom-15">
        <BaseLineProperties />
        {shipperTypes.length > 0 && (
          <li className="list__item divider--top margin-bottom-0">
            <div>
              <strong className="fs-00 lh-md">
                Additional Carrier Options
              </strong>
            </div>
            <ul className="list list--no-style">
              {shipperTypes.map((shipperType) => (
                <EditAdditionalOptions
                  key={shipperType}
                  shipperType={shipperType}
                  singleShipperType={shipperTypes.length === 1}
                />
              ))}
            </ul>
          </li>
        )}
      </ul>
      {shipperTypes.includes(UPS) && (
        <div className="label-config__carrier-fine-print">
          UPS, the UPS shield trademark, the UPS Ready mark, the UPS Developer
          Kit mark and the Color Brown are trademarks of United Parcel Service
          of America, Inc. All Rights Reserved.
        </div>
      )}
      {shipperTypes.includes(FEDEX) && (
        <div className="label-config__carrier-fine-print">
          FedEx service marks are owned by Federal Express Corporation and are
          used by permission.
        </div>
      )}
    </div>
  )
}
